import React, { useState, useEffect } from 'react'
import { Option, Select } from '../style'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps, functionsType } from '../types'

const SelectFunctionsComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  const [ functions, setFunctions ] = useState<functionsType[]>([])
  
  useEffect(() => {
    ApiService.productionFlow.getFunctions()
      .then((response: any) => {
        if(response.data) setFunctions(response.data)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }, [])
  
  const handleSelectFunction = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (setCompany && company) {
      setCompany((prev:any) => {
        const functionId = Number(e.target.value)
        const isRepeated = prev.functions.filter((f:any) => f.id == functionId)
        if(isRepeated.length > 0) return prev
        const functionObject = functions.filter(f => f.id == functionId)
        return {
          ...prev,
          functions:[...prev.functions, functionObject[0]]
        }
      })
    }
  }
  
  return(
    <div>
      <Select value='' onChange={handleSelectFunction}>
        <option value=''>Selecione</option>
        {functions.map((item, index) => 
          <Option value={item.id} key={index}>{item.name}</Option>
        )}
      </Select>
    </div>
  )
  
}

export default SelectFunctionsComponent